"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconSizes = exports.iconColors = void 0;
var _colors = require("./colors");
var iconColors = {
  brand01: _colors.palette.blue100,
  brand02: _colors.palette.charcoal,
  brand03: _colors.palette.powder,
  brand04: _colors.palette.purple100,
  brand05: _colors.palette.red100,
  brand06: _colors.palette.green100,
  brand07: _colors.palette.blueGray50,
  error: _colors.palette.danger70,
  info: _colors.palette.info100,
  success: _colors.palette.success100,
  successLight: _colors.palette.success70,
  warning: _colors.palette.warning70,
  white: _colors.palette.white
};
exports.iconColors = iconColors;
var iconSizes = {
  xxs: '10px',
  xs: '14px',
  sm: '24px',
  md: '32px',
  lg: '42px',
  xl: '60px'
};
exports.iconSizes = iconSizes;